class TeamGrid extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.increment = Number(this.getAttribute('data-increment')) || 8
    this.initialCount = Number(this.getAttribute('data-initial-count')) || 24
    this.showMoreLabel =
      this.getAttribute('data-show-more-label') ||
      window.theme.strings.showMore
    this.showLessLabel =
      this.getAttribute('data-show-less-label') ||
      window.theme.strings.showLess
    this.onToggle = this.onToggle.bind(this)

    if (this.els?.['show-more']?.exists) {
      this.listeners.add(this.els['show-more'].element, 'click', this.onToggle)
    }

    this.sortItems()
    this.applyInitialVisibility()
  }

  sortItems () {
    const items = this.els?.item?.elements

    if (!items?.length) return

    const grid = items[0].parentElement
    const sortedItems = Array.from(items).sort((itemA, itemB) => {
      return this.getPosition(itemA) - this.getPosition(itemB)
    })

    sortedItems.forEach((item) => {
      grid.appendChild(item)
    })
  }

  getPosition (item) {
    const position = Number(item.dataset.position)

    if (Number.isFinite(position) !== true) return 9999

    return position
  }

  applyInitialVisibility () {
    const items = this.els?.item?.elements

    if (!items) return

    items.forEach((item, index) => {
      if (index >= this.initialCount) return

      item.removeAttribute('hidden')
    })
  }

  onToggle () {
    const items = this.els?.item?.elements

    if (!items) return

    const hiddenItems = Array.from(items).filter((item) => {
      return item.hasAttribute('hidden')
    })

    if (hiddenItems.length === 0) {
      this.showLess()
      return
    }

    this.showMore(hiddenItems)
  }

  showMore (hiddenItems) {
    hiddenItems.slice(0, this.increment).forEach((item) => {
      item.removeAttribute('hidden')
    })

    if (hiddenItems.length <= this.increment) {
      this.setExpanded(true)
    }
  }

  showLess () {
    Array.from(this.els.item.elements).forEach((item, index) => {
      if (index >= this.initialCount) {
        item.setAttribute('hidden', '')
      }
    })

    this.setExpanded(false)
    this.scrollSectionIntoView()
  }

  scrollSectionIntoView () {
    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    ).matches

    this.scrollIntoView({
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
      block: 'start',
    })
  }

  setExpanded (isExpanded) {
    if (!this.els?.['show-more']?.exists) return

    this.els['show-more'].element.classList.toggle(
      'sec-TeamGrid_ShowMore-less',
      isExpanded,
    )

    if (this.els?.label?.exists) {
      this.els.label.element.textContent = isExpanded
        ? this.showLessLabel
        : this.showMoreLabel
    }
  }
}

if (!customElements.get('team-grid')) {
  customElements.define('team-grid', TeamGrid)
}
